import { ChangeDetectorRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, Directive, Injector, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, ControlContainer, FormControlDirective } from '@angular/forms';
import { Entity } from '@jms/model';
import { ObjectHelper } from '@jms/utils/util.helper';

export enum PickerMode {
    ReadOnly = 'ReadOnly',
    Single = 'Single',
}

export enum PickerDisplay {
    Always = 'Always',
    InplaceEdit = 'InplaceEdit'
}

export enum PickerFetch {
    Automatic = 'Automatic',
    Manual = 'Manual',
    OnDemand = 'OnDemand'
}

@Directive()
export abstract class BasePickerComponent<T, SEARCHER> implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {

    @Input() public placeholder: string;
    @Input() public valueField = '_id';
    @Input() public textField = 'name';

    @Input() public mode = PickerMode.Single;
    @Input() public fetch = PickerFetch.Automatic;
    @Input() public display = PickerDisplay.Always;

    @Input() public appendTo;

    @Input() public emptyText = 'Not Set';
    @Input() public hideSelected: boolean = false;

    private _data: T[];
    private _originalData: T[];

    @Input() public set data(items: T[]) {
        this._data = items;
        this.cdr.markForCheck();
    }

    public get data(): T[] {
        return this._data;
    }

    @Output() filterChange = new EventEmitter<string>();

    // public control: FormControl;
    private _searcher: SEARCHER;
    protected abstract registerSearcher(): SEARCHER;
    protected abstract search(searcher: SEARCHER, filter?: any): void;

    public controlContainer: ControlContainer;

    //  @ViewChild(FormControlDirective, { static: true }) formControlDirective: FormControlDirective;
    @Input() formControl: UntypedFormControl;

    @Input() formControlName: string;

    get control() {
        return this.formControl || this.controlContainer.control.get(this.formControlName);
    }

    constructor(private cdr: ChangeDetectorRef, private injector: Injector) {
        // this.control = new FormControl();

        this.controlContainer = this.injector.get(ControlContainer, null);

    }

    registerOnTouched(fn: any): void {
        //  this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }

    registerOnChange(fn: any): void {
        //  this.formControlDirective.valueAccessor.registerOnChange(fn);
    }

    writeValue(obj: any): void {
        //  this.formControlDirective.valueAccessor.writeValue(obj);
    }

    setDisabledState(isDisabled: boolean): void {
        // this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
    }

    public ngOnInit(): void {

        if (this.mode !== PickerMode.ReadOnly)
            this._searcher = this.registerSearcher();

        if (this.mode !== PickerMode.ReadOnly && this.fetch === PickerFetch.Automatic)
            this.search(this._searcher);

        this._originalData = this._data && [...this._data];
    }

    public ngOnChanges(changes: SimpleChanges) {

        if (this._searcher) {

            if (this.mode !== PickerMode.ReadOnly && this.fetch === PickerFetch.Automatic)
                this.search(this._searcher);
        }
    }

    public ngOnDestroy(): void { }

    // @Input() public set value(value: any) {
    //     this.writeValue(value);
    // }

    // public get value(): any {
    //     return this.control.value;
    // }

    // onChange: (value) => {};
    // onTouched: () => {};

    notifyValueChange(): void {
        // if (this.onChange) {
        //     this.onChange(this.value);
        // }
    }

    // writeValue(value: any): void {

    //     this.control.setValue(value);
    //     this.control.updateValueAndValidity();
    // }

    // registerOnChange(fn: any): void {
    //     this.onChange = fn;
    // }

    // registerOnTouched(fn: any): void {
    //     this.onTouched = fn;
    // }

    // setDisabledState(isDisabled: boolean): void {
    //     if (isDisabled) {
    //         this.control.disable();
    //     } else {
    //         this.control.enable();
    //     }
    // }

    public onFilterChange(filter: any) {
        if (ObjectHelper.isString(filter)) {
            if (this.fetch === PickerFetch.Automatic)
                this.search(this._searcher, filter);
            else {
                this._data = this._originalData && this._originalData.filter(i => this.findIndexOf(i[this.textField], filter));
            }
        } else
            this.filterChange.emit(filter);
    }

    public searchFn(term: string, item: Entity) {
        term = term.toLocaleLowerCase();
        const name = item.name ? item.name.toLocaleLowerCase() : '';

        if (!name) return false;

        return name.indexOf(term) > -1 || name.toLocaleLowerCase() === term;
    }

    public compareFn(data1: Entity, data2: Entity): Boolean {
        // data will included category & subcategory
        if (!data1?._id || !data2?._id) {
            return false;
        }

        const same = data1?._id === data2?._id;
        return same;
    }

    protected getSeacher(): SEARCHER {
        return this._searcher;
    }

    private findIndexOf(fieldText: string, searchText: string): boolean {
        searchText = searchText.toLocaleLowerCase().trim();
        fieldText = fieldText.toLocaleLowerCase().trim();
        return fieldText.indexOf(searchText) >= 0;
    }
}
